<script>
// import Moment from 'moment'

export default {
  /**
   * 成功 true / エラー false
   * @param params
   * @returns {boolean}
   */
  isValid: function (params) {
    var validation = this.validate(params)
    var valid = true
    for (var key in validation) {
      if (validation[key] !== false) {
        valid = false
      }
    }
    return valid
  },
  validate: function (params) {
    var validate = {}
    for (var key in params) {
      var data = params[key]
      if (key === 'company_name') {
        validate.company_name = false
        if (!data.trim()) {
          validate.company_name = '企業名を入力してください。'
        }
      }
      if (key === 'company_url') {
        validate.company_url = false
        if (!data.trim()) {
          validate.company_url = 'ホームページURLを入力してください。'
        }
      }
      if (key === 'company_station') {
        validate.company_station = false
        if (!data.trim()) {
          validate.company_station = '最寄駅を入力してください。'
        }
      }
      if (key === 'company_review') {
        validate.company_review = false
        if (!data.trim()) {
          validate.company_review = '口コミを入力してください。'
        }
      }
      if (key === 'project_working_time') {
        validate.project_working_time = false
        if (!data.trim()) {
          validate.project_working_time = '就業時間を入力してください。'
        }
      }
      if (key === 'project_title') {
        validate.project_title = false
        if (!data.trim()) {
          validate.project_title = '案件名を入力してください。'
        }
      }
      if (key === 'project_member_num') {
        validate.project_member_num = false
        if (!data.trim()) {
          validate.project_member_num = '案件に関わった人数を入力してください。'
        }
      }
      if (key === 'project_attach_season') {
        validate.project_attach_season = false
        if (!data.trim()) {
          validate.project_attach_season = '案件に関わった時期を入力してください。'
        }
      }

      // // 複数選択項目
      // if (key === 'occupation_id') {
      //   validate.occupation_id = false
      //   if (!data.length) {
      //     validate.occupation_id = '雇用形態を選択してください。'
      //   }
      // }
      // if (key === 'language_id') {
      //   validate.language_id = false
      //   if (!data.length) {
      //     validate.language_id = '言語を選択してください。'
      //   }
      // }
      // if (key === 'framework_id') {
      //   validate.framework_id = false
      //   if (!data.length) {
      //     validate.framework_id = 'フレームワークを選択してください。'
      //   }
      // }
      // if (key === 'tool_id') {
      //   validate.tool_id = false
      //   if (!data.length) {
      //     validate.tool_id = '使用したソフト等を選択してください。'
      //   }
      // }
    }
    return validate
  }
}
</script>



// WEBPACK FOOTER //
// Review.vue?32f10da8